/* --- WebPro EGYEDI MEGOLDÁS: Főmenü Click esemény és Hover blokkolás  (megamenü hover effect eltüntetését kérték)--- */
document.addEventListener('DOMContentLoaded', function() {
  const menuDetails = document.querySelectorAll('.header__inline-menu details');

  // 1. Hover blokkolás (Megállítjuk az Ella sablon saját scriptjeit)
  function killHover(e) {
    if (window.innerWidth > 1024) {
      e.stopPropagation();
      e.stopImmediatePropagation(); 
    }
  }

  menuDetails.forEach(detail => {
    detail.addEventListener('mouseenter', killHover, true);
    detail.addEventListener('mouseover', killHover, true);
    detail.addEventListener('mouseleave', killHover, true);

    const summary = detail.querySelector('summary');
    if (summary) {
      summary.addEventListener('click', function(e) {
        if (window.innerWidth <= 1024) return; // Mobilon hagyjuk a gyárit futni

        if(detail.querySelector('.mega-menu__content') || detail.querySelector('.header__submenu-wrapper')){
           e.preventDefault();
           e.stopImmediatePropagation(); 
        }

        // Másik menü bezárása, ha nyitva lenne
        menuDetails.forEach(sibling => {
          if (sibling !== detail) {
            sibling.classList.remove('is-clicked');
            sibling.removeAttribute('open');
          }
        });

        // Átváltjuk a kattintott menüt
        detail.classList.toggle('is-clicked');
        if (detail.classList.contains('is-clicked')) {
            detail.setAttribute('open', '');
        } else {
            detail.removeAttribute('open');
        }
      }, true); 
    }
  });

  // 2. Bezárás, ha máshová kattintanak
  document.addEventListener('click', function(e) {
    if (window.innerWidth > 1024 && !e.target.closest('.header__inline-menu')) {
      menuDetails.forEach(detail => {
        detail.classList.remove('is-clicked');
        detail.removeAttribute('open');
      });
    }
  });
});

/* Klaviyo gomb magyarázó szöveg beszúrása (Többnyelvű)*/
document.addEventListener("DOMContentLoaded", function() {
  // Lekérdezzük a HTML lang attribútumot (ha nincs, magyar lesz az alap)
  var currentLang = document.documentElement.lang || 'hu'; 
  
  var helperString = currentLang.includes('en') 
        ? "Enter your email address and we'll notify you when the product is available again." 
        : "Add meg az e-mail-címedet, és értesítünk, amint a termék ismét elérhető.";

  var checkKlaviyo = setInterval(function() {
    var klaviyoBtn = document.querySelector('.klaviyo-bis-trigger');
    
    if (klaviyoBtn && !document.querySelector('.klaviyo-helper-text')) {
      var helperText = document.createElement('p');
      helperText.className = 'klaviyo-helper-text'; 
      helperText.innerText = helperString; 
      helperText.style.fontSize = "1.2rem"; 
      helperText.style.marginBottom = "8px"; 
      helperText.style.color = "var(--color-foreground)"; 

      klaviyoBtn.parentNode.insertBefore(helperText, klaviyoBtn);
      clearInterval(checkKlaviyo); 
    }
  }, 500); 

  setTimeout(function() { clearInterval(checkKlaviyo); }, 10000);
});